import {
	FETCH_STORES_BEGIN,
	FETCH_STORES_SUCCESS,
	FETCH_TINY_STORES_BEGIN,
	FETCH_TINY_STORES_SUCCESS,
	FETCH_TINY_STORES_WITH_OPERATOR_BEGIN,
	FETCH_TINY_STORES_WITH_OPERATOR_SUCCESS,
	GET_FILTERED_STORES
} from '../actions/storesActions';

const defaultStoresState =  {
	stores: [],
	pagination: {},
	loading: false,
	error: null
};
const defaultTinyStoresState = {
	tinyStores: [],
	loading: false,
	error: null
}
const defaultTinyStoresWithOperatorState =  {
	tinyStoresWithOperator: [],
	pagination: {},
	loading: false,
	error: null
};

export const storesReducer = (state = defaultStoresState, action) => {
	switch (action.type) {
	case FETCH_STORES_BEGIN:
		return {
			...state,
			loading: true,
			error: null
		};

	case FETCH_STORES_SUCCESS:
		return {
			...state,
			loading: false,
			stores: action.payload.stores,
			pagination: {
				numberOfElements : action.payload.numberOfElements,
				totalElements: action.payload.totalElements,
				totalPages: action.payload.totalPages
			},
		};
	default:
		return state;
	}
};


export const filteredStoresList = (state = defaultStoresState, action) => {
    switch (action.type) {
        case GET_FILTERED_STORES:
            return {
                ...state,
                stores: action.stores
            };
        default:
            return state;
    }
};

export const tinyStoresReducer = (state = defaultTinyStoresState, action) => {
	switch (action.type) {
		case FETCH_TINY_STORES_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			};

		case FETCH_TINY_STORES_SUCCESS:
			return {
				...state,
				loading: false,
				tinyStores: action.payload.tinyStores,
			};
		default:
			return state;
	}
};

export const tinyStoresWithOperatorReducer = (state = defaultTinyStoresWithOperatorState, action) => {
	switch (action.type) {
		case FETCH_TINY_STORES_WITH_OPERATOR_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			};

		case FETCH_TINY_STORES_WITH_OPERATOR_SUCCESS:
			return {
				...state,
				loading: false,
				tinyStoresWithOperator: action.payload.tinyStoresWithOperator,
				pagination: {
					numberOfElements : action.payload.numberOfElements,
					totalElements: action.payload.totalElements,
					totalPages: action.payload.totalPages
				},
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/stores.js